import { http } from '@/http/axios.js';

// 用户列表
export function getListAPI(params) {
  return http({
    url: '/adminapi/roster/page',
    method: 'get',
    params
  })
}
// 新增名单
export function addRosterAPI(data) {
  return http({
    url: '/adminapi/roster/add',
    method: 'post',
    data
  })
}
// 删除名单
export function delRosterAPI(data) {
  return http({
    url: '/adminapi/roster/delete',
    method: 'post',
    data
  })
}
